import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STRINGS = {
  es: {
    // Topbar
    'topbar.search': 'Buscar...',
    'topbar.light': 'Modo claro',
    'topbar.dark': 'Modo oscuro',
    // Sidebar
    'nav.dashboard': 'Dashboard',
    'nav.visual_dashboard': 'Dashboard Visual',
    'nav.uploads': 'Cargar reportes',
    'nav.analytics': 'Analítica',
    'nav.forecasting': 'Pronóstico',
    'nav.comparisons': 'Comparativos',
    'nav.profit_margin': 'Profit / Margen',
    'nav.protection_plans': 'Plan de protección MFS',
    'nav.commissions': 'Comisiones',
    'nav.ar317': 'AR317 · Pagos',
    'nav.payments_orphans': 'Pagos sin orden',
    'nav.deliveries': 'Entregas (TE326)',
    'nav.inventory': 'Inventario (IC338)',
    'nav.inventory_reports': 'Reportes Ejecutivos',
    'nav.inventory_zero_sales': 'Sin ventas (IC338⨉TE395)',
    'nav.inventory_aged': 'Productos antiguos (≥30d)',
    'nav.dead_stock': 'Inventario muerto · sin venta',
    'nav.product_catalog': 'Catálogo de productos',
    'nav.merch_sets': 'Sets de Mercancía',
    'nav.collections': 'Colecciones',
    'nav.tags_audit': 'Auditoría de tags',
    'nav.reconciliation': 'Conciliación',
    'nav.alerts': 'Alertas',
    'nav.catalog': 'Catálogo oficial',
    'nav.goals': 'Metas por tienda',
    'nav.stores': 'Tiendas',
    'nav.sellers': 'Vendedores',
    'nav.tickets': 'Pedidos recientes',
    'nav.reports': 'Reportes',
    'nav.goals_vs_actual': 'Metas vs Vendido',
    'nav.top10': 'Top 10',
    'nav.challenges': 'Retos del día',
    'nav.engagement': 'Engagement · Podium',
    'nav.settings': 'Configuración',
    'nav.users': 'Usuarios',
    'nav.audit': 'Historial',
    'nav.admin': 'Administración',
    'nav.myperf': 'Mi desempeño',
    'nav.logout': 'Cerrar sesión',
    // Login
    'login.tagline': 'TE301 · TE395 · Plataforma de ventas',
    'login.subtitle': 'Ingresa tus credenciales para continuar',
    'login.email': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.submit': 'Iniciar sesión',
    'login.loading': 'Iniciando...',
    'login.demo': 'Demo: admin@canales.mx / demo1234 (o cualquier correo + 6+ caracteres)',
    'login.quote': 'El éxito es la suma de pequeños esfuerzos repetidos. ✨',
    'login.footer': 'Un ticket a la vez',
    'login.password_placeholder': 'Mínimo 6 caracteres',
    'login.email_placeholder': 'usuario@empresa.com',
    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.subtitle': 'Resumen general de operaciones · Julio 2025',
    'kpi.sales_month': 'Ventas del mes',
    'kpi.tickets_today': 'Tickets hoy',
    'kpi.avg_ticket': 'Ticket promedio',
    'kpi.active_sellers': 'Vendedores activos',
    'kpi.goal': 'Meta',
    'kpi.yesterday': 'Ayer',
    'kpi.vs_prev_month': 'vs. mes anterior',
    'kpi.paused_seller': 'vendedor pausado',
    'dashboard.working_days_banner': 'Meta calculada por días laborales',
    'dashboard.working_days_month': 'Días laborales del mes',
    'dashboard.elapsed': 'Transcurridos',
    'dashboard.daily_target': 'Meta diaria',
    'dashboard.daily_run': 'Ritmo real',
    'dashboard.visual_target_note': 'La meta visual sugerida ($5,000) es solo referencia',
    'dashboard.weekly_sales_by_store': 'Ventas semanales por tienda',
    'dashboard.last_7_days': 'Últimos 7 días',
    'dashboard.sales_by_category': 'Ventas por categoría',
    'dashboard.distribution_month': 'Distribución del mes',
    'dashboard.monthly_trend': 'Tendencia mensual',
    'dashboard.sales_vs_goal': 'Ventas vs. meta',
    'dashboard.compliance': 'Cumplimiento',
    'dashboard.recent_activity': 'Actividad reciente',
    'dashboard.last_operations': 'Últimas operaciones',
    'dashboard.top_sellers': '🐓 Top gallos y gallas del mes',
    'dashboard.sellers_rank_by_sales': 'Ranking por monto vendido',
    'dashboard.view_all': 'Ver todos',
    'table.rank': '#',
    'table.seller': 'Vendedor',
    'table.store': 'Tienda',
    'table.tickets': 'Tickets',
    'table.sales': 'Ventas',
    'table.goal_progress': 'Avance meta',
    // Goal projection
    'goal.title': 'Proyección de meta mensual',
    'goal.subtitle': 'Basado en TE301 y días laborales (Lun-Sáb)',
    'goal.on_track': 'En camino',
    'goal.at_risk': 'Riesgo de incumplimiento',
    'goal.month_goal': 'Meta del mes',
    'goal.actual_today': 'Real al día de hoy',
    'goal.projection_eom': 'Proyección fin de mes',
    'goal.missing_extra': 'Faltan / Sobran',
    'goal.working_day': 'Día laboral',
    'goal.remaining': 'quedan',
    'goal.need_per_day': 'Para alcanzar la meta necesitas',
    'goal.next_days': 'durante los próximos',
    'goal.days_unit': 'días',
    'goal.per_day': 'diarios',
    // AI panel
    'ai.suggestions': 'Sugerencias de IA',
    'ai.suggestions_subtitle': 'Recomendaciones accionables basadas en tus datos',
    'ai.generate_tips': 'Generar tips',
    'ai.regenerate': 'Regenerar',
    'ai.listen': 'Escuchar',
    'ai.stop': 'Detener',
    'ai.click_generate': 'Haz clic en',
    'ai.generate_hint': 'para recibir sugerencias de IA basadas en tus reportes.',
    // Uploads
    'uploads.title': 'Cargar reportes',
    'uploads.subtitle': 'Sube archivos XLSX de pedidos (TE301) y transacciones (TE395)',
    'uploads.drop_or_click': 'Arrastra tus archivos aquí o haz clic',
    'uploads.drop_hint': 'Formato: .xlsx — se detecta automáticamente si es TE301 (pedidos) o TE395 (productos)',
    'uploads.processing': 'Procesando...',
    'uploads.history': 'Historial de cargas',
    'uploads.history_subtitle': 'Archivos procesados recientemente',
    'uploads.no_files': 'Aún no hay archivos cargados',
    'uploads.upload_first': 'Sube tu primer reporte XLSX para comenzar',
    // Analytics
    'analytics.title': 'Analítica',
    'analytics.subtitle': 'Información agregada de los archivos TE301 y TE395 cargados',
    'analytics.no_data_title': 'Sin datos cargados',
    'analytics.merch': 'Mercancía (TE301)',
    'analytics.profit': 'Utilidad bruta',
    'analytics.product_sales': 'Ventas productos (TE395)',
    'analytics.warranties': 'Planes de protección MFS vendidos',
    'analytics.margin': 'Margen',
    'analytics.top_sellers_by_merch': 'Top vendedores por mercancía',
    'analytics.export_orders': 'Exportar pedidos',
    'analytics.top_brands': 'Top marcas por ventas',
    'analytics.top_products': 'Productos más vendidos',
    'analytics.daily_sales_te301': 'Ventas por día (TE301)',
    'analytics.filtering': 'Filtrando',
    'analytics.all_period': 'Mostrando todo el período',
    'analytics.data_range': 'Datos',
    // Commissions
    'commissions.title': 'Comisiones',
    'commissions.subtitle': 'Solo vendedores reciben comisión · fuente: TE395',
    'commissions.banner': 'Las comisiones se pagan únicamente a vendedores. Las tiendas y los distritos sirven sólo como agrupadores para análisis — no reciben comisión propia.',
    'sellers.title': 'Vendedores',
    'sellers.subtitle': 'Catálogo oficial · Comisión = 1% del TE395 transaccionado · meta mensual $50,000',
    'sellers.in_catalog': 'Vendedores en catálogo',
    'sellers.with_data': 'con datos',
    'sellers.te301_written': 'TE301 · Escritas',
    'sellers.te395_transacted': 'TE395 · Transaccionadas',
    'sellers.commission_1pct': 'Comisiones (1%)',
    'sellers.target_progress': 'Avance meta $50k',
    'catalog.title': 'Catálogo oficial',
    'catalog.subtitle': 'Lista oficial de tiendas y vendedores de Mueblería Canales (Storis)',
    'catalog.banner_title': 'Universo cerrado.',
    'catalog.banner_text': 'Esta es la lista oficial de tiendas y vendedores activos en Storis para Mueblería Canales. Cualquier nombre o código que aparezca en TE301/TE395/AR317/RECAP fuera de esta lista debe revisarse (probable typo, vendedor dado de baja, o archivo corrupto).',
    'catalog.read_only': 'Solo lectura',
    'catalog.add_store': 'Agregar tienda',
    'catalog.add_seller': 'Agregar vendedor',
    'catalog.export_csv': 'Exportar CSV',
    'common.search': 'Buscar',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.add': 'Agregar',
    'common.edit': 'Editar',
    'common.delete': 'Eliminar',
    'common.actions': 'Acciones',
    'common.no_results': 'Sin resultados',
    'filter.banner_label': 'Vista filtrada por tienda:',
    'filter.banner_clear': 'Quitar filtro',
    'commissions.total_commissions': 'Comisiones totales',
    'commissions.sellers': 'Vendedores',
    'commissions.stores_districts': 'Tiendas / Distritos',
    'commissions.sales_by_district': 'Ventas por distrito',
    'commissions.total_distribution': 'Distribución total',
    'commissions.top10_by_commission': 'Top 10 vendedores por comisión',
    'commissions.cumulative': 'Comisiones acumuladas',
    'commissions.by_store': 'Comisiones por tienda',
    'commissions.store_perf': 'Desempeño por sucursal',
    'commissions.detail_seller': 'Detalle por vendedor',
    'commissions.full_recap': 'Recap completo de comisiones',
    // AR317
    'ar317.title': 'AR317 · Pagos',
    'ar317.subtitle': 'Dashboard exclusivo para archivos AR317',
    'ar317.net_amount': 'Monto neto',
    'ar317.avg_ticket': 'Ticket promedio',
    'ar317.stores': 'Tiendas',
    'ar317.payment_types': 'Tipos de pago',
    'ar317.customers': 'Clientes',
    'ar317.amount_by_store': 'Monto por tienda',
    'ar317.top_stores_by_volume': 'Top tiendas por volumen neto',
    'ar317.payment_type': 'Tipo de pago',
    'ar317.net_distribution': 'Distribución neta',
    'ar317.payment_classes': 'Clases de pago',
    'ar317.top_customers': 'Top clientes por monto',
    'ar317.transactions': 'Transacciones',
    'ar317.no_data_title': 'Sin archivo AR317 cargado',
    // Reconciliation
    'recon.title': 'Conciliación AR317 ↔ TE301',
    'recon.subtitle': 'Cruce automático de pagos AR317 contra pedidos TE301',
    'recon.billed': 'Facturado',
    'recon.collected': 'Cobrado',
    'recon.paid': 'Pagados',
    'recon.partial': 'Parciales',
    'recon.pending': 'Pendientes',
    'recon.unmatched': 'Pagos sin pedido asociado',
    'recon.collection_rate': 'Tasa de cobro',
    // Alerts
    'alerts.title': 'Alertas',
    'alerts.subtitle': 'Detección automática de anomalías operativas',
    'alerts.critical': 'Críticas',
    'alerts.warning': 'Atención',
    'alerts.info': 'Información',
    'alerts.briefing': 'Briefing ejecutivo de IA',
    'alerts.briefing_subtitle': 'Resumen y acciones prioritarias',
    'alerts.generate_briefing': 'Generar briefing',
    'alerts.detected': 'Alertas detectadas',
    'alerts.refresh': 'Actualizar',
    'alerts.all_ok': 'Todo en orden',
    'alerts.no_alerts': 'No detectamos alertas relevantes en este momento.',
    // Forecasting
    'forecast.title': 'Pronóstico',
    'forecast.subtitle': 'Predicción de ventas TE301 con regresión lineal',
    'forecast.model_label': 'Modelo: regresión lineal sobre',
    'forecast.days_history': 'días históricos',
    'forecast.horizon': 'Horizonte',
    'forecast.avg_daily_hist': 'Promedio diario histórico',
    'forecast.median': 'Mediana',
    'forecast.trend': 'Tendencia',
    'forecast.slope': 'Pendiente',
    'forecast.projection': 'Proyección',
    'forecast.working_days': 'días laborales',
    'forecast.avg_projected': 'Promedio proyectado',
    'forecast.per_working_day': 'por día laboral',
    'forecast.chart_title': 'Histórico + Pronóstico',
    'forecast.chart_subtitle': 'Línea sólida = real. Línea punteada azul = pronóstico. Banda gris = intervalo de confianza.',
    'forecast.actual_sales': 'Ventas reales',
    'forecast.forecast_line': 'Pronóstico',
    // Comparisons
    'compare.title': 'Comparativos',
    'compare.subtitle': 'Periodo A vs Periodo B con análisis IA',
    'compare.period_a': 'Periodo A',
    'compare.period_b': 'Periodo B',
    'compare.ai_analysis': 'Análisis IA',
    'compare.ai_hint': 'Cambios principales, hipótesis y acciones',
    'compare.analyze_ai': 'Analizar con IA',
    // Generic
    'common.loading': 'Cargando...',
    'common.export': 'Exportar',
    'common.excel': 'Excel',
    'common.pdf': 'PDF',
    'common.close': 'Cerrar',
    'common.all': 'Todos',
    'common.language': 'Idioma',
  },
  en: {
    'topbar.search': 'Search...',
    'topbar.light': 'Light mode',
    'topbar.dark': 'Dark mode',
    'nav.dashboard': 'Dashboard',
    'nav.visual_dashboard': 'Visual Dashboard',
    'nav.uploads': 'Upload reports',
    'nav.analytics': 'Analytics',
    'nav.forecasting': 'Forecasting',
    'nav.comparisons': 'Comparisons',
    'nav.profit_margin': 'Profit / Margin',
    'nav.protection_plans': 'Protection Plans',
    'nav.commissions': 'Commissions',
    'nav.ar317': 'AR317 · Payments',
    'nav.payments_orphans': 'Payments w/o order',
    'nav.deliveries': 'Deliveries (TE326)',
    'nav.inventory': 'Inventory (IC338)',
    'nav.inventory_reports': 'Executive Reports',
    'nav.inventory_zero_sales': 'Zero-sales (IC338⨉TE395)',
    'nav.inventory_aged': 'Aged products (≥30d)',
    'nav.dead_stock': 'Dead stock · no sales',
    'nav.product_catalog': 'Product catalog',
    'nav.merch_sets': 'Merchandise Sets',
    'nav.collections': 'Collections',
    'nav.tags_audit': 'Tags Audit',
    'nav.reconciliation': 'Reconciliation',
    'nav.alerts': 'Alerts',
    'nav.catalog': 'Official catalog',
    'nav.goals': 'Store goals',
    'nav.stores': 'Stores',
    'nav.sellers': 'Sellers',
    'nav.tickets': 'Recent orders',
    'nav.reports': 'Reports',
    'nav.goals_vs_actual': 'Goals vs Actual',
    'nav.top10': 'Top 10',
    'nav.challenges': 'Daily Challenges',
    'nav.engagement': 'Engagement · Podium',
    'nav.settings': 'Settings',
    'nav.users': 'Users',
    'nav.audit': 'Audit log',
    'nav.admin': 'Administration',
    'nav.myperf': 'My performance',
    'nav.logout': 'Sign out',
    'login.tagline': 'TE301 · TE395 · Sales platform',
    'login.subtitle': 'Enter your credentials to continue',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.submit': 'Sign in',
    'login.loading': 'Signing in...',
    'login.demo': 'Demo: admin@canales.mx / demo1234 (or any email + 6+ chars)',
    'login.quote': 'Success is the sum of small efforts, repeated. ✨',
    'login.footer': 'One ticket at a time',
    'login.password_placeholder': 'At least 6 characters',
    'login.email_placeholder': 'user@company.com',
    'dashboard.title': 'Dashboard',
    'dashboard.subtitle': 'Operations overview · July 2025',
    'kpi.sales_month': 'Monthly sales',
    'kpi.tickets_today': 'Tickets today',
    'kpi.avg_ticket': 'Average ticket',
    'kpi.active_sellers': 'Active sellers',
    'kpi.goal': 'Goal',
    'kpi.yesterday': 'Yesterday',
    'kpi.vs_prev_month': 'vs. previous month',
    'kpi.paused_seller': 'paused seller',
    'dashboard.working_days_banner': 'Goal calculated by working days',
    'dashboard.working_days_month': 'Working days in month',
    'dashboard.elapsed': 'Elapsed',
    'dashboard.daily_target': 'Daily target',
    'dashboard.daily_run': 'Actual run rate',
    'dashboard.visual_target_note': 'The visual suggested goal ($5,000) is just a reference',
    'dashboard.weekly_sales_by_store': 'Weekly sales by store',
    'dashboard.last_7_days': 'Last 7 days',
    'dashboard.sales_by_category': 'Sales by category',
    'dashboard.distribution_month': 'Monthly distribution',
    'dashboard.monthly_trend': 'Monthly trend',
    'dashboard.sales_vs_goal': 'Sales vs. goal',
    'dashboard.compliance': 'Compliance',
    'dashboard.recent_activity': 'Recent activity',
    'dashboard.last_operations': 'Latest operations',
    'dashboard.top_sellers': '🐓 Top gallos & gallas of the month',
    'dashboard.sellers_rank_by_sales': 'Ranked by sales amount',
    'dashboard.view_all': 'View all',
    'table.rank': '#',
    'table.seller': 'Seller',
    'table.store': 'Store',
    'table.tickets': 'Tickets',
    'table.sales': 'Sales',
    'table.goal_progress': 'Goal progress',
    'goal.title': 'Monthly goal projection',
    'goal.subtitle': 'Based on TE301 and working days (Mon-Sat)',
    'goal.on_track': 'On track',
    'goal.at_risk': 'At risk',
    'goal.month_goal': "Month's goal",
    'goal.actual_today': 'Actual as of today',
    'goal.projection_eom': 'End-of-month projection',
    'goal.missing_extra': 'Missing / Over',
    'goal.working_day': 'Working day',
    'goal.remaining': 'remaining',
    'goal.need_per_day': 'To reach the goal you need',
    'goal.next_days': 'over the next',
    'goal.days_unit': 'days',
    'goal.per_day': 'per day',
    'ai.suggestions': 'AI suggestions',
    'ai.suggestions_subtitle': 'Actionable recommendations based on your data',
    'ai.generate_tips': 'Generate tips',
    'ai.regenerate': 'Regenerate',
    'ai.listen': 'Listen',
    'ai.stop': 'Stop',
    'ai.click_generate': 'Click',
    'ai.generate_hint': 'to receive AI suggestions based on your reports.',
    'uploads.title': 'Upload reports',
    'uploads.subtitle': 'Upload XLSX files for orders (TE301) and transactions (TE395)',
    'uploads.drop_or_click': 'Drag your files here or click to select',
    'uploads.drop_hint': 'Format: .xlsx — automatically detected as TE301 (orders) or TE395 (products)',
    'uploads.processing': 'Processing...',
    'uploads.history': 'Upload history',
    'uploads.history_subtitle': 'Recently processed files',
    'uploads.no_files': 'No files uploaded yet',
    'uploads.upload_first': 'Upload your first XLSX report to start',
    'analytics.title': 'Analytics',
    'analytics.subtitle': 'Aggregated insights from TE301 and TE395 uploaded files',
    'analytics.no_data_title': 'No data uploaded',
    'analytics.merch': 'Merchandise (TE301)',
    'analytics.profit': 'Gross profit',
    'analytics.product_sales': 'Product sales (TE395)',
    'analytics.warranties': 'Warranties sold',
    'analytics.margin': 'Margin',
    'analytics.top_sellers_by_merch': 'Top sellers by merchandise',
    'analytics.export_orders': 'Export orders',
    'analytics.top_brands': 'Top brands by sales',
    'analytics.top_products': 'Top selling products',
    'analytics.daily_sales_te301': 'Daily sales (TE301)',
    'analytics.filtering': 'Filtering',
    'analytics.all_period': 'Showing full period',
    'analytics.data_range': 'Data',
    'commissions.title': 'Commissions',
    'commissions.subtitle': 'Only salespeople receive commissions · source: TE395',
    'commissions.banner': 'Commissions are paid only to salespeople. Stores and districts are grouping aggregations only — they do not receive their own commission.',
    'sellers.title': 'Salespeople',
    'sellers.subtitle': 'Official catalog · Commission = 1% of TE395 transacted · monthly target $50,000',
    'sellers.in_catalog': 'Salespeople in catalog',
    'sellers.with_data': 'with data',
    'sellers.te301_written': 'TE301 · Written',
    'sellers.te395_transacted': 'TE395 · Transacted',
    'sellers.commission_1pct': 'Commissions (1%)',
    'sellers.target_progress': 'Progress to $50k',
    'catalog.title': 'Official catalog',
    'catalog.subtitle': 'Official list of stores and salespeople for Mueblería Canales (Storis)',
    'catalog.banner_title': 'Closed universe.',
    'catalog.banner_text': 'This is the official list of stores and salespeople active in Storis for Mueblería Canales. Any name or code that appears in TE301/TE395/AR317/RECAP outside this list should be reviewed (likely typo, retired salesperson, or corrupt file).',
    'catalog.read_only': 'Read only',
    'catalog.add_store': 'Add store',
    'catalog.add_seller': 'Add salesperson',
    'catalog.export_csv': 'Export CSV',
    'common.search': 'Search',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.actions': 'Actions',
    'common.no_results': 'No results',
    'filter.banner_label': 'Filtered by store:',
    'filter.banner_clear': 'Clear filter',
    'commissions.total_sales': 'Total sales',
    'commissions.total_commissions': 'Total commissions',
    'commissions.sellers': 'Sellers',
    'commissions.stores_districts': 'Stores / Districts',
    'commissions.sales_by_district': 'Sales by district',
    'commissions.total_distribution': 'Total distribution',
    'commissions.top10_by_commission': 'Top 10 sellers by commission',
    'commissions.cumulative': 'Cumulative commissions',
    'commissions.by_store': 'Commissions by store',
    'commissions.store_perf': 'Performance by branch',
    'commissions.detail_seller': 'Detail by seller',
    'commissions.full_recap': 'Full commission recap',
    'ar317.title': 'AR317 · Payments',
    'ar317.subtitle': 'Dedicated dashboard for AR317 files',
    'ar317.net_amount': 'Net amount',
    'ar317.avg_ticket': 'Average ticket',
    'ar317.stores': 'Stores',
    'ar317.payment_types': 'Payment types',
    'ar317.customers': 'Customers',
    'ar317.amount_by_store': 'Amount by store',
    'ar317.top_stores_by_volume': 'Top stores by net volume',
    'ar317.payment_type': 'Payment type',
    'ar317.net_distribution': 'Net distribution',
    'ar317.payment_classes': 'Payment classes',
    'ar317.top_customers': 'Top customers by amount',
    'ar317.transactions': 'Transactions',
    'ar317.no_data_title': 'No AR317 file uploaded',
    'recon.title': 'Reconciliation AR317 ↔ TE301',
    'recon.subtitle': 'Automatic cross-check of AR317 payments against TE301 orders',
    'recon.billed': 'Billed',
    'recon.collected': 'Collected',
    'recon.paid': 'Paid',
    'recon.partial': 'Partial',
    'recon.pending': 'Pending',
    'recon.unmatched': 'Payments without matching order',
    'recon.collection_rate': 'Collection rate',
    'alerts.title': 'Alerts',
    'alerts.subtitle': 'Automatic detection of operational anomalies',
    'alerts.critical': 'Critical',
    'alerts.warning': 'Warning',
    'alerts.info': 'Information',
    'alerts.briefing': 'AI executive briefing',
    'alerts.briefing_subtitle': 'Summary and priority actions',
    'alerts.generate_briefing': 'Generate briefing',
    'alerts.detected': 'Detected alerts',
    'alerts.refresh': 'Refresh',
    'alerts.all_ok': 'All clear',
    'alerts.no_alerts': 'No relevant alerts at this time.',
    'forecast.title': 'Forecasting',
    'forecast.subtitle': 'Sales forecast from TE301 using linear regression',
    'forecast.model_label': 'Model: linear regression over',
    'forecast.days_history': 'historical days',
    'forecast.horizon': 'Horizon',
    'forecast.avg_daily_hist': 'Historical daily average',
    'forecast.median': 'Median',
    'forecast.trend': 'Trend',
    'forecast.slope': 'Slope',
    'forecast.projection': 'Projection',
    'forecast.working_days': 'working days',
    'forecast.avg_projected': 'Projected average',
    'forecast.per_working_day': 'per working day',
    'forecast.chart_title': 'History + Forecast',
    'forecast.chart_subtitle': 'Solid line = actual. Blue dashed = forecast. Gray band = confidence interval.',
    'forecast.actual_sales': 'Actual sales',
    'forecast.forecast_line': 'Forecast',
    'compare.title': 'Comparisons',
    'compare.subtitle': 'Period A vs Period B with AI analysis',
    'compare.period_a': 'Period A',
    'compare.period_b': 'Period B',
    'compare.ai_analysis': 'AI analysis',
    'compare.ai_hint': 'Key changes, hypotheses and actions',
    'compare.analyze_ai': 'Analyze with AI',
    'common.loading': 'Loading...',
    'common.export': 'Export',
    'common.excel': 'Excel',
    'common.pdf': 'PDF',
    'common.close': 'Close',
    'common.all': 'All',
    'common.language': 'Language',
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'es';
    return localStorage.getItem('canales_lang') || 'es';
  });

  useEffect(() => { localStorage.setItem('canales_lang', lang); }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    t: (key, fallback) => (STRINGS[lang] && STRINGS[lang][key]) || (STRINGS.es[key]) || fallback || key,
  }), [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext) || { lang: 'es', setLang: () => {}, t: (k, f) => f || k };
